import { render, staticRenderFns } from "./productSpec__list.vue?vue&type=template&id=2f5a0c2a"
import script from "./productSpec__list.vue?vue&type=script&lang=js"
export * from "./productSpec__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports